import { createApolloClient } from './apollo';
import { createTreatyClient } from './rest';

import { makeAutoObservable } from 'mobx';

export * from './apollo';
export * from './rest';

export class ClientStore {
  constructor() {
    makeAutoObservable(this);
  }

  get treatyClient() {
    return createTreatyClient();
  }

  get apolloClient() {
    return createApolloClient();
  }

  async clearClients() {
    await this.apolloClient.clearStore();
    await this.apolloClient.resetStore();
  }
}

export const clientStore = new ClientStore();
